import styled from "styled-components";

type MorePolicemanModalContentProps = {
  isApprovalModal: boolean;
};

export const MorePolicemanModalContent = styled.div<MorePolicemanModalContentProps>`
  display: flex;
  flex: flex-column;
  justify-content: center;
  align-items: center;
  margin: auto;
  width: ${({ isApprovalModal }) => (isApprovalModal ? "60vw" : "39.5rem")};
  height: 85vh;
  border-radius: 4px;
  background: var(--black-200) !important;
  border: none !important;
`;

export const MorePolicemanModalOverlay = styled.div`
  background-color: rgba(25, 25, 25, 0.75) !important;
  inset: 0;
  width: 100vw;
  height: 100vh;
  position: fixed;
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
`;

export const MorePolicemanHeader = styled.div`
  width: 100%;
  padding-top: 1.1rem;

  header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 1.5rem;
    padding-bottom: 1.25rem;
    width: 100%;
    border-bottom: 1px solid rgba(82, 82, 82, 0.64);

    img {
      cursor: pointer;
    }
  }
`;

export const MorePolicemanDetailsContent = styled.div`
  width: 100%;
  overflow: auto;

  label {
    margin-bottom: 0.25rem;
    color: var(--white);
    font-weight: 500;
    font-size: 1.0275rem;
  }
`;

export const MorePolicemanContainer = styled.div`
  width: 100%;
  padding: 1.75rem;
  overflow-y: hidden;
  border-right: 1px solid #3d3d3d;

  h3 {
    margin-bottom: 1.5rem;
    font-weight: semi-bold;
  }

  h3:last-of-type {
    margin-top: 1.5rem;
  }

  p {
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 0.875rem;
    line-height: 1.5rem;
    color: var(--grey-100);
  }
`;

export const BadgeContainer = styled.div`
  padding: 0.8rem;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--black-300);
  width: 100%;

  span {
    text-align: center;
  }
`;

export const DataContainer = styled.div`
  margin-bottom: 35px;
`;

export const MorePolicemanContent = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 1.75rem;

  &:last-of-type {
    span:last-of-type {
      grid-column: span 2;
    }
  }
`;

export const PolicemanPictures = styled.div`
  width: 100%;
  height: 20rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
`;

export const Footer = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: row;
  padding: 0.5rem;
  gap: 1rem;

  button {
    flex-grow: 1;
  }
`